import Icon from '../components/Icon.vue'

Icon.register({
  'pause-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM240 336C240 344.8 232.8 352 224 352H176C167.2 352 160 344.8 160 336V176C160 167.2 167.2 160 176 160H224C232.8 160 240 167.2 240 176V336zM352 336C352 344.8 344.8 352 336 352H288C279.2 352 272 344.8 272 336V176C272 167.2 279.2 160 288 160H336C344.8 160 352 167.2 352 176V336z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pause-circle.js
// module id = MEqO
// module chunks = 144